import {
  calculateFinances,
  UserData,
  calculateSipFutureValue,
  formatRupeeLiteral,
} from '../../../constants';

const InvestmentPlanGrowth = {
  label: 'Recommended Investment Plans',
  sections: [
    {
      type: 'text',
      text:
        '<br><h5>This investment plan is the most popular<br />with people of your Age & Income.</h5>',
    },
    {
      type: 'cards',
      cards: [
        {
          title: 'Aggressive Growth',
          returns: '15.3',
          doubledIn: (user: UserData) => {
            const taxData = calculateFinances(user);
            const aggressivePlan = calculateSipFutureValue(
              taxData.sipAmount,
              25,
              15
            );
            return `
            Rs. ${
              taxData.sipAmount
            } invested every month can become up to Rs. ${formatRupeeLiteral(
              aggressivePlan
            )} in ${taxData.aggressiveYears} years`;
          },
          link: '/save/plan/26',
          highlighted: true,
          planId: 26,
        },
      ],
    },
    {
      type: 'text',
      text: () => {
        return `<br/>
        <small class="light">
          Clicking these buttons will open in a new tab and will not affect your filing
        </small>`;
      },
    },
  ],
};

export default InvestmentPlanGrowth;



// WEBPACK FOOTER //
// ./components/recommendation/cards/investmentPlanGrowth.ts